import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Typography, Link } from "@mui/material";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtCmb from "./CustomTool/CtCmb";
import CtDtp from "./CustomTool/CtDtp";
import CtBtn from "./CustomTool/CtBtn";
import CollapsibleTable from "./CustomTool/CollapsibleTable";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import AMCFollowUpList from "./AMCFollowUpList";
import AMCFollowUpEntry from "./AMCFollowUpEntry";
import AMCGetLocation from "./AMCGetLocation";
import AMCRevise from "./AMCRevise";
import AMCLost from "./AMCLost";
import AMCMailPreview from "./AMCMailPreview";
import AMCBlock from "./AMCBlock";
import AMCUnblock from "./AMCUnblock";
import Final from "./Final";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RefreshIcon from "@mui/icons-material/Refresh";
import DescriptionIcon from "@mui/icons-material/Description";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FollowTheSignsIcon from "@mui/icons-material/FollowTheSigns";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import MailIcon from "@mui/icons-material/Mail";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";

class AMCRenewal extends Component {
  state = {
    formData: {
      branch: "",
      renewalMonth: "",
      renewalYear: "",
    },
    ARD: null,
    columns: [
      { accessorKey: "branch", header: "Branch" },
      { accessorKey: "siteName", header: "Site name" },
      { accessorKey: "totalLifts", header: "Number of Lifts", align: "center" },
      { accessorKey: "contractType", header: "Contract Type" },
      { accessorKey: "currentPeriod", header: "Current Period" },
      { accessorKey: "currentPrice", header: "Current Price", align: "right" },
      { accessorKey: "renewalFormDate", header: "Renewal Form Date" },
      { accessorKey: "renewalToDate", header: "Renewal To Date" },

      {
        accessorKey: "totalProposedPrice",
        header: "Total Proposed Price",
        align: "right",
      },
    ],
    detailColumns: [
      { accessorKey: "name", header: "Lift Name" },
      { accessorKey: "code", header: "Lift Code" },
      {
        accessorKey: "yearlyService",
        header: "Yearly Lift Service",
        align: "center",
      },
      { accessorKey: "currentPrice", header: "Current Price", align: "right" },
      {
        accessorKey: "proposedPrice",
        header: "Proposed Price",
        align: "right",
      },
    ],
    rows: [
      {
        allAction: true,
        documentNo: "TOP/AMC/BVN/25-26/03",
        branch: "Bhavnagar",
        siteName: "Aarohi Complex",
        totalLifts: "03",
        contractType: "Popular",
        currentPeriod: "01/01/2025 TO 31/12/2025",
        currentPrice: "1,10,000",
        renewFromDate: get_YMD_from_SYS(new Date()),
        renewToDate: get_YMD_from_SYS(new Date()),
        totalProposedPrice: "2,00,000",
        lifts: [
          {
            name: "Lift A",
            code: "BVN11060001",
            yearlyService: 13,
            currentPrice: "1,00,000",
            proposedPrice: "1,00,000",
          },
          {
            name: "Lift B",
            code: "BVN11060002",
            yearlyService: 12,
            currentPrice: "90,000",
            proposedPrice: "90,000",
          },
        ],
      },
      {
        allAction: false,
        documentNo: "TOP/AMC/BVN/25-26/04",
        siteName: "Aarohi Complex",
        contractType: "Regular",
        totalLifts: 2,
        totalAmount: "1,50,000",
        payment: "Advance",
        contractStage: "Final",
        currentPeriod: "01/01/2025 TO 31/12/2025",
        lifts: [
          {
            block: false,
            name: "Lift C",
            code: "BVN11060006",
            yearlyService: 10,
            amount: "75,000",
          },
          {
            block: false,
            name: "Lift D",
            code: "BVN11060007",
            yearlyService: 12,
            amount: "75,000",
          },
        ],
      },
    ],
  };

  componentDidMount() {
    document.title = "AMC Renewal";
    localStorage.setItem("Heading", "AMC Renewal");
    document.getElementById("branch").focus();
  }

  handleOnChange = (e) => {
    const { name, value } = e.target;

    if (name === "renewFromDate_1" || name === "renewToDate_2") {
      this.setState(
        (prev) => {
          if (!prev.rows.length) {
            return null;
          }
          const rows = [...prev.rows];
          const row = { ...rows[0] };
          if (name === "renewFromDate_1") {
            row.renewFromDate = value;
          } else {
            row.renewToDate = value;
          }
          rows[0] = row;
          return { rows };
        },
        () => {
          this.setfrom_todate();
        },
      );
      return;
    }

    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
    }));
  };

  setfrom_todate = () => {
    this.setState((prev) => {
      if (!prev.rows.length) {
        return null;
      }
      const rows = [...prev.rows];
      const row = { ...rows[0] };

      if (row.renewFromDate && row.renewToDate) {
        if (row.renewToDate < row.renewFromDate) {
          row.renewToDate = row.renewFromDate;
          rows[0] = row;
          return { rows };
        }
      }
      return null;
    });
  };

  handleEditLift = (rtRow, detailRow) => {
    if (this.props.navigate) {
      this.props.navigate("/AMCLiftInfo");
    }
  };

  handleDeleteLift = (rtRow, detailRow) => {
    if (detailRow && detailRow.code) {
      this.props.toastMsg(
        "success",
        `Lift Delete Successfully : ${detailRow.code}`,
      );
      return;
    }
    this.props.toastMsg("success", "Lift Delete Successfully");
  };

  handleBlockLift = () => {
    this.props.toastMsg("success", "Lift Blocked Successfully");
  };

  handleWhatsApp = () => {
    this.props.toastMsg("success", "WhatsApp action");
  };

  handleonClickDeleteContract = (rtRow) => {
    const contractNo = rtRow && rtRow.documentNo ? rtRow.documentNo : undefined;
    if (contractNo) {
      this.props.toastMsg(
        "success",
        `Contract Delete Successfully : ${contractNo}`,
      );
      return;
    }
    this.props.toastMsg("success", "Contract Delete Successfully");
  };

  handleRemoveFromFinal = (rtRow) => {
    const contractNo = rtRow && rtRow.documentNo ? rtRow.documentNo : undefined;
    if (contractNo) {
      this.props.toastMsg(
        "success",
        `Removed From Final Successfully : ${contractNo}`,
      );
      return;
    }
    this.props.toastMsg("success", "Removed From Final Successfully");
  };

  openFollowUpList = () => {
    this.openARD("Follow Up List", <AMCFollowUpList />);
  };

  openFollowUpEntry = () => {
    this.openARD("Follow Up Entry", <AMCFollowUpEntry />);
  };

  openGetLocation = () => {
    this.openARD("Get Location", <AMCGetLocation />);
  };

  openReviseAMC = () => {
    this.openARD("Revise AMC", <AMCRevise />);
  };

  openLostAMC = () => {
    this.openARD("Lost AMC", <AMCLost />);
  };

  openMailPreview = () => {
    this.openARD("Mail Preview", <AMCMailPreview />);
  };

  openBlockAMC = () => {
    this.openARD("Block AMC", <AMCBlock />);
  };

  openFinalPayment = () => {
    this.openARD("Final Advance Payment AMC", <Final />);
  };

  openARD = (heading, content) => {
    this.setState({ ARD: null }, () => {
      const ARD = (
        <AlertResponsiveDialog
          alertHeading={heading}
          labelDisagree="Close"
          alertMessage={content}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={() => {
            document.title = "AMC Registration";
            localStorage.setItem("Heading", "AMC Registration");
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          branch: "",
          renewalMonth: "",
          renewalYear: "",
        },
      },
      () => {
        document.getElementById("branch")?.focus();
      },
    );
  };

  GenerateRenewal = () => {
    if (!this.validationAMCRenewal()) return;
    this.props.toastMsg("success", "AMC Renewal Generate Successfully");
    this.clearInfo();

    // navigate after save if needed
    // this.props.navigateTo("AMCRenewal");
  };

  validationAMCRenewal = () => {
    const { formData } = this.state;
    if (!formData.branch) {
      this.props.toastErrorMsg("Select Branch", "branch");
      return false;
    }
    if (!formData.renewalMonth) {
      this.props.toastErrorMsg("Select Renewal Month", "renewalMonth");
      return false;
    }
    if (!formData.renewalYear) {
      this.props.toastErrorMsg("Select Renewal Year", "renewalYear");
      return false;
    }
    return true;
  };
  render() {
    const { formData } = this.state;
    const rowsdata = this.state.rows.map((row, index) => {
      const fromId =
        index === 0 ? "renewFromDate_1" : `renewFromDate_${index + 1}`;
      const toId = index === 0 ? "renewToDate_2" : `renewToDate_${index + 1}`;

      return {
        ...row,
        renewalFormDate: (
          <Grid item>
            <CtDtp
              id={fromId}
              label="From Date"
              value={row.renewFromDate}
              handleOnChange={this.handleOnChange}
              width={120}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={toId}
            />
          </Grid>
        ),
        renewalToDate: (
          <Grid item>
            <CtDtp
              id={toId}
              label="To Date"
              value={row.renewToDate}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              width={120}
            />
          </Grid>
        ),
      };
    });

    return (
      <form>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCRenewalList">
            AMC Renewal
          </Link>
          <Typography sx={{ color: "text.primary" }}>
            Generate Renewal
          </Typography>
        </Breadcrumbs>

        <Grid container spacing={2} marginTop={2}>
          <Grid item>
            <CtCmb
              id="branch"
              label="Branch"
              value={formData.branch}
              items={["Bhavnagar", "Rajkot", "Baroda", "Surat"]}
              width={240}
              maxLength={100}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"renewalMonth"}
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="renewalMonth"
              label="Renewal Month"
              value={formData.renewalMonth}
              items={[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ]}
              width={240}
              maxLength={100}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"renewalYear"}
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="renewalYear"
              label="Renewal Year"
              value={formData.renewalYear}
              items={["2024", "2025", "2026"]}
              width={200}
              maxLength={100}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={""}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={2}
        >
          <Grid item className="maintable" xs={12} style={{ width: "100%" }}>
            <CollapsibleTable
              columnsdata={this.state.columns}
              rowsdata={rowsdata}
              detailColumnsdata={this.state.detailColumns}
              detailRowKey="lifts"
              menuActions={(row) =>
                row && row.allAction
                  ? [
                      {
                        label: "Print",
                        icon: <PrintIcon />,
                        onClick: () => {},
                      },
                      {
                        label: "PDF",
                        icon: <PictureAsPdfIcon />,
                        onClick: () => {},
                      },
                      {
                        label: "Revise",
                        icon: <RefreshIcon />,
                        onClick: this.openReviseAMC,
                      },
                      {
                        label: "Edit Contract",
                        icon: <DescriptionIcon />,
                        onClick: () => {
                          if (this.props.navigate) {
                            this.props.navigateTo("ContractDetail", {
                              contract: "Existing AMC",
                            });
                          }
                        },
                      },
                      {
                        label: "Final",
                        icon: <CheckCircleIcon />,
                        onClick: this.openFinalPayment,
                      },
                      {
                        label: "WhatsApp",
                        icon: <WhatsAppIcon sx={{ color: "#25D366" }} />,
                        onClick: this.handleWhatsApp,
                      },
                      {
                        label: "Follow Up",
                        icon: <FollowTheSignsIcon />,
                        onClick: () => {
                          if (this.props.navigate) {
                            this.props.navigate("/AMCFollowUpList");
                          }
                        },
                      },
                      {
                        label: "Lost",
                        icon: <ReportProblemIcon sx={{ color: "#ff9800" }} />,
                        onClick: this.openLostAMC,
                      },
                      {
                        label: "Delete",
                        icon: <DeleteIcon sx={{ color: "#d32f2f" }} />,
                        onClick: this.handleonClickDeleteContract,
                      },
                      {
                        label: "Mail",
                        icon: <MailIcon />,
                        onClick: this.openMailPreview,
                      },
                    ]
                  : [
                      {
                        label: "Print",
                        icon: <PrintIcon />,
                        onClick: () => {},
                      },
                      {
                        label: "PDF",
                        icon: <PictureAsPdfIcon />,
                        onClick: () => {},
                      },
                      {
                        label: "WhatsApp",
                        icon: <WhatsAppIcon sx={{ color: "#25D366" }} />,
                        onClick: this.handleWhatsApp,
                      },
                      {
                        label: "Remove From Final",
                        icon: (
                          <RemoveCircleOutlineIcon sx={{ color: "#d32f2f" }} />
                        ),
                        onClick: this.handleRemoveFromFinal,
                      },
                    ]
              }
              liftRowActions={[
                {
                  label: "Edit",
                  icon: <EditIcon fontSize="small" />,
                  onClick: this.handleEditLift,
                },
                {
                  label: "Delete",
                  icon: <DeleteIcon fontSize="small" />,
                  color: "#d32f2f",
                  onClick: this.handleDeleteLift,
                },
                {
                  label: "Block",
                  icon: <BlockIcon fontSize="small" />,
                  onClick: this.handleBlockLift,
                },
              ]}
            />
          </Grid>
        </Grid>

        <Grid item>
          <div style={{ textAlign: "right" }}>{this.state.ARD}</div>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={4}
        >
          <Grid item>
            <CtBtn label="Generate Excel" className="secondary-button" />
          </Grid>
          <Grid item>
            <CtBtn
              label="Generate Renewal"
              className="new-button"
              onClick={this.GenerateRenewal}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Generate Renewal & WhatsApp"
              className="success-button"
              iconName={"WhatsAppIcon"}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCRenewal {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
